import { Component, OnInit, ViewChild } from '@angular/core';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { GridService } from 'app/Shared/Services/grid.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import {default as UserLogGridCol} from 'app/Pages/administration/user-log/user-log-gridColumns.json'
import { ConstantService } from 'app/Shared/Services/constant-service';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { Table, TableModule } from 'primeng/table';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LowerCasePipe, NgClass, CommonModule} from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-user-log',
    templateUrl: './user-log.component.html',
    imports: [FilterPanelComponent, TableModule, MatProgressSpinner, NgClass, CommonModule, LowerCasePipe]
})
export class UserLogComponent implements OnInit {
  @ViewChild(('dt')) dt!: Table;
  userLogGridCols: any ;
  totalRecords!: number;
  gridColumns:any;
  userLogDataset:any = [];
  data:any;
  userLogGridColumns: any;
  defaultFilterArray: any ;
  isLoadingResults: boolean = true;
  constructor(private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService, 
    private userService: UserService,
    public constantService: ConstantService,
    private gridService: GridService) { }

  ngOnInit() {
    this.defaultFilterArray = [
        {
          "isdefault": "true",
          "label": "Date",
          "columnname": "l.Created_Date",
          "filterby": "IS",
          "values": [
            new Date(),
            new Date()
          ],
          "time": "",
          "datatype": "DateRange",
          "disabled": "true",
          "dropdown": "",
          "dropdownvalue": ""
        },
        {
          "isdefault": "true",
          "label": "UserId",
          "columnname": "u.User_Name",
          "filterby": "IS",
          "values": this.userService.isRoleSuperUser() ? "" : this.userService.userName,
          "time": "",
          "datatype": "String",
          "disabled": "true",
          "dropdown": "YES",
          "dropdowntype" : "singleselect",
          "dropdownvalue":   this.userService.isRoleSuperUser() ?this.getUserIdDropdownValue() : [{ label: 'Current User', value: this.userService.userName }],
        }
      ];  
      this.gridColumns =  [
        { header: "Date", field: "date", datatype: "String", display: "true" },
        { header: "Login Time", field: "loginTime", datatype: "String", display: "true" },
        { header: "User Id", field: "userName", datatype: "String", display: "true" },
        { header: "First Name", field: "firstName", datatype: "String", display: "true" },
        { header: "Last Name", field: "lastName", datatype: "String", display: "true" },
        { header: "Logout Time", field: "logoutTime", datatype: "String", display: "true" },
        { header: "Role", field: "roleName", datatype: "String", display: "true" },
         { header: "UI Version", field: "uiVersion", datatype: "String", display: "true" },
        { header: "IP Address", field: "IPAddress", datatype: "String", display: "true" },
        { header: "Region", field: "region", datatype: "String", display: "true" },
        { header: "Country", field: "country", datatype: "String", display: "true" },
        { header: "Browser", field: "browser", datatype: "String", display: "true" },
        { header: "Browser Version", field: "browser_version", datatype: "String", display: "true" }

      ];
    this.totalRecords =this.constantService.DEFAULT_ROWSIZE
    this.getData();
  }

  getUserIdDropdownValue() {
    let dropdown =[];     
    dropdown.push({ label: 'All Users', value: '' },{ label: 'Current Users', value: this.userService.userName });
    return dropdown;
  }
  getData() {
    this.isLoadingResults = true;
    let payload = {
      mpid: this.userService.getActiveMPID(),
      data: this.defaultFilterArray
    }
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.userLog
        ), payload)
        .subscribe({ next:(res:any) => {
          this.userLogDataset = res.data;
          this.isLoadingResults = false;
          this.totalRecords=this.userLogDataset.length;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);

      }, error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
    }});
  }
  FilterApplyFilterEvent(event:any) {
    this.defaultFilterArray = [];
    this.defaultFilterArray = event;
    this.getData();
  }

}
